import { SUPPORT_REFER } from "../../../../../errors/errorMessages"
import { snackbar } from "../../../../../utils/general/generalUtils"
import { postClientProtected } from "../../../clients/clients"
import { POST_USER_ASSIGNMENT } from "../../../urls/private"

export interface IPostApplicationAssignment {
    postUsersId: (userId: string, resetOnFail: () => void) => Promise<void>
}

const usePostApplicationAssignment = (
    applicationId: string
): IPostApplicationAssignment => {
    const postUsersId = async (
        userId: string,
        resetOnFail: () => void
    ): Promise<void> => {
        try {
            await postClientProtected(
                POST_USER_ASSIGNMENT(userId, applicationId),
                null
            )
        } catch {
            resetOnFail()
            snackbar(
                `Unable to assign to user. Please try again. ${SUPPORT_REFER}`,
                "warning"
            )
        }
    }
    return {
        postUsersId,
    }
}

export default usePostApplicationAssignment
